"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAvererBffSessionActive = exports.clearAvererBffSession = exports.markAvererBffSessionActive = void 0;
/* eslint-disable no-undef */
const AVERER_BFF_SESSION_KEY = "avererBffSession";
const getLocalStorage = () => {
    try {
        const storage = globalThis.localStorage;
        if (!storage) {
            return undefined;
        }
        storage.getItem(AVERER_BFF_SESSION_KEY);
        return storage;
    }
    catch {
        return undefined;
    }
};
/**
 * Marks the browser as using an Averer BFF HttpOnly cookie session (not Firebase bearer).
 * Uses localStorage so the flag is visible across tabs, matching the shared session cookie.
 */
const markAvererBffSessionActive = () => {
    getLocalStorage()?.setItem(AVERER_BFF_SESSION_KEY, "true");
};
exports.markAvererBffSessionActive = markAvererBffSessionActive;
/** Clears the Averer BFF session marker after sign-out or Firebase sign-in. */
const clearAvererBffSession = () => {
    getLocalStorage()?.removeItem(AVERER_BFF_SESSION_KEY);
};
exports.clearAvererBffSession = clearAvererBffSession;
/** True when the client should prefer the Averer cookie over a lingering Firebase session. */
const isAvererBffSessionActive = () => getLocalStorage()?.getItem(AVERER_BFF_SESSION_KEY) === "true";
exports.isAvererBffSessionActive = isAvererBffSessionActive;
//# sourceMappingURL=avererBffSessionStorage.js.map